// 빈 폼 기본값
export const EMPTY_FORM = {
  teamName: '',
  entityStatus: '',
  establishedDate: '',
  location: '',
  ceo: '',
  gender: '',
  participant: '',
  participantTitle: '',
  participantNationality: '',
  industry: '',
  businessItem: '',
  website: '',
  socialMedia: '',
  promotionalVideo: '',
  informationChannel: '',
  privacyAgreement: true
};

// 정보 채널 라디오 버튼 데이터 배열
export const INFORMATION_CHANNELS = [
  { id: 'social', value: 'social', label: 'KSGC Official Social Media (Facebook, LinkedIn, Instagram, YouTube)' },
  { id: 'advertising', value: 'advertising', label: 'Advertising (Online banner, Video Ads, Social media Ads, etc.)' },
  { id: 'journal', value: 'journal', label: 'Journal (IT/Tech Newspaper, Magazine)' },
  { id: 'email', value: 'email', label: 'E-mail (Newsletter, eDM)' },
  { id: 'recommendations', value: 'recommendations', label: 'Recommendations from Acquaintances' },
  { id: 'organizations', value: 'organizations', label: 'Startup-related Organizations' },
  { id: 'search', value: 'search', label: 'Search Engine' },
  { id: 'others', value: 'others', label: 'Others' }
];

// 엔티티 상태 선택 옵션
export const ENTITY_STATUS_OPTIONS = [
  { value: 'Pre-established', label: 'Pre-established' },
  { value: 'Corporation', label: 'Corporation' }
];

// 파일 선택 텍스트
export const FILE_SELECT_TEXT = 'Please select a document file (DOC, DOCX, PDF) or image (JPG, JPEG)';

// 알림 메시지
export const NOTIFICATION_MESSAGES = {
  DRAFT_EDITING: 'You are currently editing a draft application. You must complete and submit it before the deadline.',
  SUBMITTED_EDITING: 'You are currently editing an already submitted application. To save your changes, you must submit it again before the deadline.'
}; 